export default __webpack_public_path__ + "static/media/image-xx59.77d41dad.jpg";